import {isFunction, isObject, isUndefined} from 'lodash';

/**
 * @see https://developer.helpscout.com/beacon-2/web/javascript-api/
 */
export default {
  isAvailable() {
    return (!isUndefined(window.Beacon) && isFunction(window.Beacon));
  },
  destroy() {
    try {
      if (this.isAvailable()) {
        window.Beacon('destroy');
      }
    } catch (e) { // MLD-3451
      console.log('Could not destroy helpscout service', e.message);
    }
  },
  init() {
    if (this.isAvailable()) {
      window.Beacon('init', 'fe860c42-d6eb-4ee9-8247-ad68adcc5f1a')
    }
  },
  track(eventName, eventData) {
    if (this.isAvailable()) {

    }
  },
  //
  update(to, from) {
    if (this.isAvailable()) {

    }
  },
  shutdown() {
    if (this.isAvailable()) {
      window.Beacon('logout');
    }
  },
  identify(user) { // MLD-2728
    try { // MLD-4893
      if (this.isAvailable() && isObject(user)) {
        const baseURL = `https://${location.hostname}`;
        let teamName = null;
        let teamRole = 'Team Member';
        if (user && isObject(user.team) && user.team.role) { // V2
          teamRole = user.team.role;
          teamName = user.team.name;
        } else if (user && user.team_role) { // V1
          teamRole = user.team_role;
          teamName = user.team_name;
        }
        const profile = {
          name: user.name,
          email: user.email,
          signature: user.helpscout_user_hmac,
          // MLD-3837
          jobTitle: user.title,
          profileURL: `${baseURL}/admin/users/${user.id}`,
          teamID: user.current_team_id,
          teamName: teamName,
          teamRole: teamRole,
          userID: user.id,
        };
        window.Beacon('identify', profile);
      }
    } catch (e) {
      console.log('helpScoutService.identify Issue()', e);
    }
  },
  show(user) {
    try {
      if (this.isAvailable()) {
        this.init();
        this.identify(user);
        window.Beacon('open');
      }
    } catch (e) {
    }
  },
  hide() {
    try {
      if (this.isAvailable()) {
        window.Beacon('close');
      }
    } catch (e) {
    }
  },
  /**
   * @see https://developer.helpscout.com/beacon-2/web/javascript-api/#beaconprefill-formobject
   * @param user
   * @param data
   */
  prefill(user, data) {
    try {
      this.show(user);
      if (this.isAvailable()) {
        window.Beacon('prefill', data);
      } else {
        console.log('Beacon is not available.');
      }
    } catch (e) {
    }
  }
}
